import { AfterViewInit, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppClientConfigurationService, AppServerAPI, ResponseMessage, ResponseStatus } from '@sdbn/common';
import { MasterDetailListEntry, TranslationService } from '@sdbn/common';
import { tap } from 'rxjs/operators';
import { InhouseContact, Visit, VisitorRoleReference } from '../../../../tmc-visit.model';
import { PersonalVisitService } from '../../personal-visit.service';

class ListEntry implements MasterDetailListEntry {
  listTitle: string;
  listTitleDictionaryKey: string;
  listSubTitle: string;
  childs: MasterDetailListEntry[];
  groupIdentifier: String;

  constructor(dictionaryKey: string) {
    this.listTitleDictionaryKey = dictionaryKey;
  }

}

@Component({
  selector: 'app-personal-visit-details-dialog',
  templateUrl: './personal-visit-details-dialog.component.html',
  styleUrls: ['./personal-visit-details-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PersonalVisitDetailsDialogComponent implements OnInit, AfterViewInit {

  types = new Array<VisitorRoleReference>();

  listEntries = [
    new ListEntry('tmc.visit.masterdata.menu.masterdata'),
    new ListEntry('tmc.visit.masterdata.menu.visited'),
    new ListEntry('tmc.visit.masterdata.menu.group'),
    new ListEntry('tmc.visit.masterdata.menu.tasks'),
    new ListEntry('tmc.visit.masterdata.menu.log')
  ];

  titleDictionaryKey = null;

  selectedIndex = 0;
  selectedEntry = this.listEntries[0];

  responseMessages: ResponseMessage[];

  visit: Visit;

  masterdataValid = false;
  hasMandatoryOpenTasks = false;

  upfrontRegistration = false;
  inEditMode = false;

  registerEntranceDefault = false;

  showRegisterEntrance = true;

  readOnly = false;

  formGroup = new FormGroup({});

  constructor(
    public dialogRef: MatDialogRef<PersonalVisitDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private personalVisitService: PersonalVisitService,
    public cps: AppClientConfigurationService,
    public translationService: TranslationService,
	private appServerAPI: AppServerAPI) {
    this.visit = data.model;

    this.upfrontRegistration = data.action === 'new-upfront' || data.action === 'edit-upfront';

    var openMandatoryTasks = false;
    if (!this.upfrontRegistration) {
      for (const task of this.visit.tasks) {
        if (!task.done && !task.optional && !task.doneBefore) {
          openMandatoryTasks = true;
        }
      }
    }
    this.hasMandatoryOpenTasks = openMandatoryTasks;

    this.readOnly = data.readOnly != null && data.readOnly === true;

    this.inEditMode = data.action === 'edit-upfront' || data.action === "edit" || data.action === 'register-entrance';

    if (data.action === 'new-upfront') {
      this.titleDictionaryKey = 'tmc-visit.dialog.details.title.new-visitor-upfront';
    } else if (data.action === 'edit-upfront') {
      this.titleDictionaryKey = 'tmc-visit.dialog.details.title.edit-visitor-upfront';
    } else if (data.action === 'new') {
      this.titleDictionaryKey = 'tmc-visit.dialog.details.title.new-visitor';
    } else if (data.action === 'edit') {
      this.titleDictionaryKey = 'tmc-visit.dialog.details.title.edit-visitor';
    } else if (data.action === 'register-entrance') {
      this.titleDictionaryKey = 'tmc-visit.dialog.details.title.register-visitor-entrance';
    }


    if (data.action === 'register-entrance' || data.action === 'new') {
      this.registerEntranceDefault = true;
      this.visit.registerEntrance = true;
    }

    this.showRegisterEntrance = !this.upfrontRegistration && !this.readOnly;
  }

  ngOnInit() {

    this.loadVisitTypes().subscribe();

    if (this.upfrontRegistration && this.inEditMode === false) { // nur bei Neuanlage
      console.log('fill ContactData......');
      this.personalVisitService.loadContactDataForloggedInUser().subscribe(response => {
        let contactData = new InhouseContact(response);
        if (this.visit.visitedPerson == null) {
          this.visit.visitedPerson = contactData;
        } else {
          this.visit.visitedPerson.mail = contactData.mail;
          this.visit.visitedPerson.name = contactData.name;
          this.visit.visitedPerson.department = contactData.department;
          this.visit.visitedPerson.phone = contactData.phone;
        }
      });

    }

    if (this.showRegisterEntrance) {
      this.formGroup.addControl('registerEntrance', new FormControl(this.registerEntranceDefault, []));
      if (!this.visit.reservation) {
        this.formGroup.controls.registerEntrance.disable();
      }
    }

    this.formGroup.valueChanges.subscribe(values => {
      this.visit.registerEntrance = values.registerEntrance;
      this.selectedIndex = this.listEntries.indexOf(this.selectedEntry);
    });

    this.selectedIndex = this.listEntries.indexOf(this.selectedEntry);
  }


  handleSelectionChange(selection: MasterDetailListEntry) {
    this.selectedEntry = selection;
    this.selectedIndex = this.listEntries.indexOf(this.selectedEntry);
  }

  ngAfterViewInit(): void {
  }

  onMasterdataValidityChanged(validity: boolean) {
    console.log('onMasterdataValidityChanged', validity);
    this.masterdataValid = validity;
  }

  onOpenTasksChanged(hasMandatoryOpenTasks: boolean) {
    console.log('onOpenTasksChanged', hasMandatoryOpenTasks);
    this.hasMandatoryOpenTasks = hasMandatoryOpenTasks;
  }

  save(): void {
    console.log('visit is', this.visit);
    this.personalVisitService.savePersonalVisit(this.visit).subscribe(response => {
      if (response.status === ResponseStatus.SUCCESS) {
        this.dialogRef.close();
      } else {
        this.responseMessages = response.responseMessages;
      }
    });
  }

  loadVisitTypes() {
    return this.appServerAPI.execute<VisitorRoleReference[]>('/client/control/personalvisit/find-visitor-roles', {}).
      pipe(
        tap((roles) => {
          const newRoles = new Array<VisitorRoleReference>();
          for (const role of roles) {
            newRoles.push(new VisitorRoleReference(role));
          }
          this.types = newRoles;
        })
      )
  }

}
